import type { TenantMemberStatus } from './tenantMember'

export type ProjectStatus = 'New' | 'InProgress' | 'Done'

export interface TeamMemberSummary {
  id: string
  name: string
}

export interface Project {
  id: string
  name: string
  description: string | null
  client: string
  type: string
  industry: string
  status: ProjectStatus
  technologiesFrom: string[]
  technologiesTo: string[]
  teamMembers?: TeamMemberSummary[]
  creationTime?: string
}

export interface TeamMemberAssignment {
  userId: string
  roleIds: string[]
}

export interface CreateProjectRequest {
  name: string
  description?: string
  client: string
  type: string
  industry: string
  technologiesFrom?: string[]
  technologiesTo?: string[]
  teamMembers?: TeamMemberAssignment[]
}

export interface ProjectTeamMember {
  userId: string
  displayName: string
  email: string
  status: TenantMemberStatus
  roles: RoleSummary[]
}

export interface RoleSummary {
  id: string
  name: string
}

export interface Technology {
  value: string
  label: string
}

export interface CreateProjectResponse {
  projectId: string
}

export interface UpdateProjectRequest {
  description?: string
  teamMembers?: TeamMemberAssignment[]
}

export interface UpdateProjectResponse {
  projectId: string
}

export const PROJECT_TYPE_LABELS: Record<string, string> = {
  Modernization: 'Modernization',
  Greenfield: 'Greenfield',
}

export const PROJECT_INDUSTRY_LABELS: Record<string, string> = {
  Logistics: 'Logistics',
  Healthcare: 'Healthcare',
  Education: 'Education',
  Energy: 'Energy',
  Finance: 'Finance',
  LegalServices: 'Legal/Compliance',
  Insurance: 'Insurance',
  HR: 'HR',
  InformationTechnology: 'Information Technology',
}

export const PROJECT_STATUS_LABELS: Record<ProjectStatus, string> = {
  New: 'New',
  InProgress: 'In Progress',
  Done: 'Done',
}

export type ProjectSortColumn = 'name' | 'client' | 'industry' | 'type'

export const PROJECT_DEFAULT_SORT_DIRECTIONS: Record<ProjectSortColumn, 'asc' | 'desc'> = {
  name: 'asc',
  client: 'asc',
  industry: 'asc',
  type: 'asc',
}

export function getStatusLabel(status: ProjectStatus | null): string {
  if (!status) return ''
  return PROJECT_STATUS_LABELS[status] ?? status
}

export function getIndustryLabel(industry: string | null): string {
  if (!industry) return ''
  return PROJECT_INDUSTRY_LABELS[industry] ?? industry
}

export function getTypeLabel(type: string | null): string {
  if (!type) return ''
  return PROJECT_TYPE_LABELS[type] ?? type
}

export interface ProjectFilters {
  search?: string
  industry?: string
  type?: string
  client?: string
  sortBy?: string
  sortDirection?: string
}
